import { render } from "./PublicationMetadata.vue?vue&type=template&id=69eadbe5&scoped=true"
import script from "./PublicationMetadata.vue?vue&type=script&lang=js"
export * from "./PublicationMetadata.vue?vue&type=script&lang=js"

import "./PublicationMetadata.vue?vue&type=style&index=0&id=69eadbe5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69eadbe5"]])

export default __exports__